<template>
  <div class="bg-white shadow-sm">
    <div class="px-6 py-4 border-b border-gray-200">
      <h2 class="text-lg font-semibold text-gray-900">Relationship Hub Controls</h2>
      <p class="text-sm text-gray-500 mt-1">{{ device.deviceId }}</p>
    </div>

    <div class="p-6 space-y-6">
      <!-- Device Status Header -->
      <DeviceStatusHeader :device="device" />

      <!-- Display Mode Control -->
      <DisplayModeControl 
        :device="device" 
        :isOnline="isOnline"
        @update-desired="handleUpdateDesired"
      />

      <!-- Middle Section Control -->
      <MiddleSectionControl
        :device="device"
        :isOnline="isOnline"
        @update-desired="handleUpdateDesired"
      />

      <!-- LED Strip Control
      <LEDStripControl 
        :device="device" 
        :isOnline="isOnline"
        @update-desired="handleUpdateDesired"
      /> -->

      <!-- Virtual LED Strip Control -->
      <div class="space-y-4">
        <div>
          <h3 class="text-base font-medium text-gray-900">Virtual LED Strips</h3>
          <p class="text-sm text-gray-500">Configure mood lighting and progress bar effects</p>
        </div>

        <!-- Mood Light (Strip 1: Pixels 0-9) -->
        <MoodLightControl 
          :device="device" 
          :isOnline="isOnline"
          @update-desired="handleUpdateDesired"
        />

        <!-- Progress Bar (Strip 2: Pixels 10-19) -->
        <ProgressBarControl 
          :device="device" 
          :isOnline="isOnline"
          @update-desired="handleUpdateDesired"
        />
      </div>

      <!-- Device Info -->
      <DeviceInfo :device="device" />

      <!-- Actions -->
      <DeviceActions 
        :device="device" 
        :isOnline="isOnline"
        @update-desired="handleUpdateDesired"
        @sync-device="handleSyncDevice"
      />
    </div>
  </div>
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import { debounce } from 'lodash-es'
import DeviceStatusHeader from './DeviceStatusHeader.vue'
import DisplayModeControl from './DisplayModeControl.vue'
import LEDStripControl from './LEDStripControl.vue'
import MoodLightControl from './MoodLightControl.vue'
import ProgressBarControl from './ProgressBarControl.vue'
import DeviceInfo from './DeviceInfo.vue'
import DeviceActions from './DeviceActions.vue'
import MiddleSectionControl from './MiddleSectionControl.vue'

const props = defineProps({
  device: {
    type: Object,
    required: true
  }
})

const emit = defineEmits(['update-desired', 'sync-device'])

// Computed properties
const isOnline = computed(() => props.device.status === 'online')

// Event handlers
const handleUpdateDesired = (deviceId, newState) => {
  emit('update-desired', deviceId, newState)
}

const handleSyncDevice = (deviceId) => {
  emit('sync-device', deviceId)
}
</script>